import { Reset } from './gb-reset';
riot.tag2('gb-reset', '<yield> <a class="gb-reset {_style}">&times;</a> </yield>', 'gb-reset .gb-stylish.gb-reset,[riot-tag="gb-reset"] .gb-stylish.gb-reset,[data-is="gb-reset"] .gb-stylish.gb-reset{ color: #888; padding: 4px; } gb-reset .gb-stylish.gb-reset:hover,[riot-tag="gb-reset"] .gb-stylish.gb-reset:hover,[data-is="gb-reset"] .gb-stylish.gb-reset:hover{ color: black; cursor: pointer; }', '', function(opts) {
    this._mixin(Reset);
});



/** WEBPACK FOOTER **
 ** ./src/tags/reset/gb-reset.tag.html
 **/